export enum CurrentPlatformType {
	WEB = 'web',
	IOS = 'ios',
	ANDROID = 'android',
}
